// extracted by mini-css-extract-plugin
export default {"container":"DesignPill_container__cNL93","active":"DesignPill_active__84i-j","image":"DesignPill_image__FQNXe","img":"DesignPill_img__nSnHt"};